import $ from 'jquery';
A.ready(() => {
    new A.Widget({
        el: '.app-guide',
        events: {
            'click #guide-close': 'hideAppGuide',
        },
        created() {
            this.kingWnd = {
                create: () => {
                    const html = `<div id="king-card">
                            <img src="https://cdn.aixifan.com/acfun-pc/2.8.36/img/page/index/download-app-king-card.png">
                        <a class="closebtn"></a>
                    </div>`;
                    $('body').append(html);
                    $('#king-card .closebtn').on('click', () => {
                        const nw = this.nextWeek();
                        A.Cookie.setCookie('king-show-today', new Date().getDate(), {
                            expires: nw,
                            path: '/',
                            domain: '.acfun.cn',
                        });
                        this.kingWnd.hide();
                    });
                },
                show: function () {
                    $('#king-card').addClass('king-card-show');
                },
                hide: function () {
                    $('#king-card').removeClass('king-card-show');
                },
            };
            // 显示大王卡推广期间内
            const isInShowKingCardPeriod = (function () {
                const time = new Date();
                const year = time.getFullYear();
                const month = time.getMonth() + 1;
                const date = time.getDate();
                return year === 2019 && month === 8 && date >= 9 && date <= 16;
            }());
            // 老用户需要重新弹窗
            const isCloseVisit = A.Cookie.getCookie('isCloseVisit');
            if (isCloseVisit && +isCloseVisit !== this.nextWeek().getTime()) {
                A.Cookie.deleteCookie('isCloseVisit', {
                    path: '/',
                });
            }
            // 大王卡推广期间为每天显示。非大王卡期间每周1显示一次
            if (isInShowKingCardPeriod && !this.isKingCardShownTodayFn()) {
                this.kingWnd.create();
                setTimeout(() => {
                    this.kingWnd.show();
                }, 1000);
            } else if ( A.Cookie.getCookie('isCloseVisit') === null && !isInShowKingCardPeriod) {
                this.el.style.display = 'block';
                window.weblog && window.weblog.sendImmediately('DOWNLOAD_APP_BANNER', {}, 'SHOW_EVENT');
            }
        },
        methods: {
            isKingCardShownTodayFn() {
                const day = +A.Cookie.getCookie('king-show-today');
                return day === new Date().getDate();
            },
            hideAppGuide() {
                this.el.className += ' app-guide-hide';
                const nw = this.nextWeek();
                A.Cookie.setCookie('isCloseVisit', nw.getTime(), {
                    expires: nw,
                    path: '/',
                    domain: '.acfun.cn',
                });
                window.weblog && window.weblog.sendImmediately('CLICK_CLOSE_BUTTON', {});
            },
            nextWeek() {
                const date = new Date();
                const ONE_DAY = 1000 * 60 * 60 * 24;
                const curDay = date.getDay(); // 当前时区下今天是星期几( 0 - 6 0为星期天)
                const diff = this.getDayToWeekend(curDay) * ONE_DAY; // 距离周末还有多久
                const weeTimeInLocale = date.setHours(0, 0, 0, 0);
                return new Date(weeTimeInLocale + diff);
            },
            getDayToWeekend(day) {
                if (day === 0) {
                    return 1;
                }
                return 8 - day;
            },
        },
    });
});